module.exports = __webpack_public_path__ + "img/Armenia.f173f2b1.gif";